import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import * as styles from "./AttributesTransfer.module.less";
import { AttributesTransferStore } from "./AttributesTransferStore";
import { AttrTransferPart } from "./AttrTransferPart";

/**
 * Компонент для выбора атрибутов из списка спецификаций
 * Состоит из двух списков. В левом - не выбранные, а в правой - выбранные.
 * Выбор нужных атрибутов осуществляется перемещением из одной половины в другую.
 */

type PropsAttributesTransfer = {
  store: AttributesTransferStore;
};

export const AttributesTransfer: React.FC<PropsAttributesTransfer> = observer(
  (props) => {
    const { store } = props;
    return (
      <div className={styles.frame}>
        <div className={styles.part}>
          <AttrTransferPart store={store.left} title="Атрибуты спецификаций" />
        </div>
        <div className={styles.middle}>
          <Button
            icon={<ArrowLeftOutlined />}
            disabled={store.right.selectedRows.length === 0}
            onClick={() => store.onRightAction()}
          />
          <Button
            icon={<ArrowRightOutlined />}
            disabled={store.left.selectedRows.length === 0}
            onClick={() => store.onLeftAction()}
          />
        </div>
        <div className={styles.part}>
          <AttrTransferPart store={store.right} title="Выбранные атрибуты" />
        </div>
      </div>
    );
  },
);
